import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getKambiSportsOfferingIntegrationOverrideSetting } from '@core/Areas/Settings/Store/selectors'
import { setNewKambiSportsOfferingIntegrationSetting } from '@core/Areas/Settings/Store'
import { SettingItemWithCheckbox } from '../Common/SettingItemWithCheckbox'
import { toggleKambiVisibility } from '@core/Areas/KambiClient/helpers'
import { setKambiClientVisibility } from '@core/Areas/KambiClient/Store'

// INTERNAL ONLY: remove when shipping wider PROD audience
export const KambiSportsOfferingIntegrationOverrideSetting: React.FC = () => {
  const dispatch = useDispatch()
  const isEnabled = useSelector(getKambiSportsOfferingIntegrationOverrideSetting)

  return (
    <SettingItemWithCheckbox
      isEnabled={isEnabled}
      label='Enable new Kambi sports offering integration'
      desciption='Internal only. Locally overrides the feature on this device.'
      onToggle={() => {
        dispatch(setNewKambiSportsOfferingIntegrationSetting(!isEnabled))
        // fix for bug where kambi client shows when toggling sport setting
        dispatch(setKambiClientVisibility(false))
        toggleKambiVisibility(false)
      }}
    />
  )
}
